import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  GetAllParentTags,
  DeleteParentTagById,
  AddParentTagApi,
  EditParentTagApi,
  GetParentTagById,
} from "../../api";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import Select from "react-select";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/AddProduct.css";
import { validateName } from "../../contexts/Utils";

const AddEditParentTag = () => {
  const navigate = useNavigate();
  const { currentColor, userID, userToken } = useStateContext();
  const location = useLocation();
  const { fromPage } = location.state || {};
  const [brand, setBrand] = useState("");
  const [getbrands, setBrands] = useState([]);
  const [brandOptions, setbrandOptions] = useState([]);
  const [brand_id, setbrand_id] = useState("");
  const [name, setName] = useState("");
  const [featrd, setFeatrd] = useState(0);
  const [rank, setRank] = useState(100);
  const [ValError, setValError] = useState([]);
  const [mode, setMode] = useState("Add");
  const [loadBtn, setLoadBtn] = useState(false);

  const validName1 = (name, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (name.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (validateName(name)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const handleChangeRank = (e) => {
    setRank(e.target.value);
  };

  const handleChangFeatrd = (e) => {
    setFeatrd((prev) => (prev === 0 ? 1 : 0));
  };

  const handleAddMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    setMode("Add");
    setBrand("");
    setbrand_id("");
    setName("");
    setRank("");
    setFeatrd(0);
  };

  const handleEditMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    setMode("Edit");
    setBrand("");
    setbrand_id("");
    setName("");
    setRank("");
  };

  const handleDeleteMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    setMode("Delete");
    setBrand("");
    setbrand_id("");
    setName("");
    setRank("");
  };

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate("/Product/AddEditTag", {
      state: { fromPage: "ParentTag" },
    });
  };

  const handleAddSubmit = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    var resp = 0;
    try {
      setValError([]);
      const updatedErrors = [...ValError];
      if (
        (mode === "Edit" || mode === "Delete") &&
        (!brand_id || brand_id === "")
      ) {
        updatedErrors[0] = "Select a Parent Tag!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";
      if (name === "") {
        updatedErrors[1] = "Please enter name!";
        setValError(updatedErrors);
        return;
      }
      if (name) {
        if (validName1(name, 1) === false) {
          return;
        }
      }
      updatedErrors[1] = "";
      // if (rank !== "") {
      //   if (ValidText1(note, 2) === false) {
      //     return;
      //   }
      // }
      // updatedErrors[2] = "";
      setValError(updatedErrors);
      if (mode === "Add") {
        if (window.confirm("Do you want to add Parent Tag?")) {
          const res = await AddParentTagApi(
            name,
            featrd,
            rank,
            userID,
            userToken,
          );
          resp = res.status;
          if (resp === 200) {
            alert("Added successfully.");
          } else {
            alert("Fail to add Parent Tag.");
          }
        }
      } else if (mode === "Edit") {
        if (window.confirm("Do you want to edit this Parent Tag?")) {
          const res = await EditParentTagApi(
            brand_id,
            name,
            featrd,
            rank,
            userID,
            userToken,
          );
          resp = res.status;
          if (resp === 200) {
            alert("Updated successfully.");
          } else {
            alert("Fail to edit Parent Tag!");
          }
        }
      } else if (mode === "Delete") {
        if (
          window.confirm(`Do you want to remove ${brand.label} Parent Tag?`)
        ) {
          const res = await DeleteParentTagById(brand_id, userID, userToken);
          resp = res.status;
          if (resp === 200) {
            alert("Removed successfully.");
          } else {
            alert("Fail to remove Parent Tag!");
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoadBtn(false);
      if (resp === 200) {
        navigate("/Product/AddEditParentTag", {
          state: { fromPage: fromPage },
        });
        window.location.reload();
      }
    }
  };

  const handleChangeBrand = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setBrand(selectedOption);
        const selected_id = selectedOption.value;
        setbrand_id(selected_id);
        const resp1 = GetParentTagById(selected_id, userID, userToken);
        resp1
          .then(function (result) {
            setName(result.data[0].name);
            setRank(result.data[0].rank);
            setFeatrd(result.data[0].featured);
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        setbrand_id("");
        setBrand(selectedOption.label);
      }
    } catch (err) {}
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (userID && userToken) {
        GetAllParentTags(userID, userToken)
          .then((resp) => {
            setBrands(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [userID, userToken]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    const fetchStoreOptions = async () => {
      const fetchedStoreOptions = getbrands.map((item) => ({
        label: `${item.name}`,
        value: item.tag_p_id,
      }));
      setbrandOptions(fetchedStoreOptions);
    };

    fetchStoreOptions();
  }, [getbrands]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header
        title={
          mode === "Add"
            ? "ADD PARENT TAG"
            : mode === "Edit"
              ? "EDIT PARENT TAG"
              : "DELETE PARENT TAG"
        }
      />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row
            xs={1}
            sm={1}
            className="justify-content-center"
            style={{ padding: "0" }}
          >
            <Col md={2} className="container-col" />
            <Col md={4} className="container-col">
              {(mode === "Edit" || mode === "Delete") && (
                <>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="label">Parent Tag List:</label>
                      <Select
                        className="myreact-select container-select"
                        value={brand}
                        onChange={handleChangeBrand}
                        options={brandOptions}
                        isSearchable
                        placeholder="Select a Parent Tag"
                      />
                      {ValError[0] && (
                        <p className="label-error-select">{ValError[0]}</p>
                      )}
                    </div>
                  </div>
                  <br />
                  <br />
                </>
              )}
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Name:</label>
                  <input
                    type="text"
                    name="pcat_name"
                    value={name}
                    onChange={handleChangeName}
                    className="input"
                    placeholder="Parent Tag Name"
                    onBlur={(e) => validName1(e.target.value, 1)}
                    disabled={mode === "Delete"}
                  />
                  {ValError[1] && <p className="label-error">{ValError[1]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Rank:</label>
                  <input
                    type="number"
                    step="1.00"
                    min="0"
                    name="Rank"
                    value={rank}
                    placeholder="Rank"
                    className="input"
                    onChange={handleChangeRank}
                    disabled={mode === "Delete"}
                  />
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="Featured"
                  checked={featrd === 1}
                  onChange={handleChangFeatrd}
                  disabled={mode === "Delete"}
                />
                {` `}Featured
              </label>
              <br />
            </Col>
            <Col md={4} className="container-col">
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Add"
                borderRadius="10px"
                onClick={handleAddMode}
              />
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Edit"
                borderRadius="10px"
                onClick={handleEditMode}
              />
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Delete"
                borderRadius="10px"
                onClick={handleDeleteMode}
              />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          color="white"
          margin="10px"
          padding="20px"
          bgColor={currentColor}
          text={
            mode === "Add" ? "ADD NEW" : mode === "Edit" ? "UPDATE" : "REMOVE"
          }
          borderRadius="10px"
          onClick={handleAddSubmit}
          disabled={loadBtn}
        />
        <Button
          color="white"
          margin="10px"
          padding="20px"
          bgColor={currentColor}
          text="BACK"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditParentTag;
